module.exports = __webpack_public_path__ + "static/media/09_CAP.dbb61823.png";